const EMAIL_DOMAIN_RULE = {
  LIST_EMAIL_DOMAIN_RULE: 'EmailDomainRule/list',
  ADD_EMAIL_DOMAIN_RULE: 'EmailDomainRule', // POST
  UPDATE_EMAIL_DOMAIN_RULE: 'EmailDomainRule', // PUT
  DELETE_EMAIL_DOMAIN_RULE: 'EmailDomainRule/{id}', // DELETE
}

export default EMAIL_DOMAIN_RULE
